import { render } from "./LikeCount.vue?vue&type=template&id=0227b989"
import script from "./LikeCount.vue?vue&type=script&lang=js"
export * from "./LikeCount.vue?vue&type=script&lang=js"

import exportComponent from "/home/aloco/alocohawaii.com/moa/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__